import { render, staticRenderFns } from "./CategoryEdit.vue?vue&type=template&id=31e4294f"
import script from "./CategoryEdit.vue?vue&type=script&lang=js"
export * from "./CategoryEdit.vue?vue&type=script&lang=js"
import style0 from "./CategoryEdit.vue?vue&type=style&index=0&id=31e4294f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports